import { render, staticRenderFns } from "./option-group-table.vue?vue&type=template&id=4192d38f&scoped=true&"
import script from "./option-group-table.ts?vue&type=script&lang=ts&"
export * from "./option-group-table.ts?vue&type=script&lang=ts&"
import style0 from "./option-group-table.scss?vue&type=style&index=0&id=4192d38f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4192d38f",
  null
  
)

export default component.exports